






































































import { Vue, Component, Model, Emit } from "vue-property-decorator";
import { formRules } from "@/const/form-rules";
import Auth from "@/controller/auth";

@Component
export default class ChangePasswordPopup extends Vue {
  @Model("input", { type: Boolean, required: true })
  show!: boolean;

  @Emit("input")
  emitClose() {
    return false;
  }

  oldPassword = "";
  newPassword = "";
  confirmPassword = "";

  isError = false;
  errorMessage = "";
  isSuccessful = false;

  formIsValid = true;
  rules = formRules;
  isChangingPassword = false;

  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  get passwordNotChanged(): boolean {
    return this.oldPassword !== "" && this.oldPassword === this.newPassword;
  }

  async onClick() {
    this.validateForm();

    if (!this.formIsValid) {
      return;
    }

    if (!this.validatePasswords()) {
      return;
    }

    await this.changePassword();
  }

  private validateForm() {
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  private validatePasswords(): boolean {
    return this.passwordsMatch && !this.passwordNotChanged;
  }

  async changePassword() {
    this.isChangingPassword = true;

    try {
      await Auth.changePassword(this.newPassword);
      this.isSuccessful = true;
    } catch (error) {
      const isWrongPassword = error.code === "auth/wrong-password";
      this.errorMessage = isWrongPassword
        ? "Mật khẩu cũ không chính xác"
        : "Lỗi hệ thống. Vui lòng thử lại sau!";
      this.isError = true;
      this.isSuccessful = false;
    } finally {
      this.isChangingPassword = false;
    }
  }
}
